import { computed } from 'vue';
import { useRoute } from 'vue-router';

export type RouteName = 'room' | 'rate' | 'details' | 'payment';

export function useCurrentBookingStep() {
  const route = useRoute();

  const currentStep = computed<RouteName>(() => {
    const match = /booking-(ridcode-)?(.+)_{3}.*/.exec(route.name as string);
    return match?.[2] as RouteName;
  });

  return { currentStep };
}
